var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("404")]),_c('div',{staticClass:"engtext"},[_vm._v("Page Not Found.")]),_c('div',{staticClass:"chitext"},[_vm._v("找不到網頁")]),_c('div',{staticClass:"push_to_home"},[_c('v-btn',{staticClass:"btn-primary white--text",on:{"click":_vm.goBackHome}},[_vm._v(" 回首頁 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }